/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Replace_Ellipses_DescInputs */

const en_replace_ellipses_desc = /** @type {(inputs: Replace_Ellipses_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace multiple dots with ellipses`)
};

const fr_replace_ellipses_desc = /** @type {(inputs: Replace_Ellipses_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer les points multiples par des points de suspension`)
};

const de_replace_ellipses_desc = /** @type {(inputs: Replace_Ellipses_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere Punkte durch Auslassungspunkte ersetzen`)
};

const it_replace_ellipses_desc = /** @type {(inputs: Replace_Ellipses_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisci più punti con ellissi`)
};

const ru_replace_ellipses_desc = /** @type {(inputs: Replace_Ellipses_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Замените несколько точек многоточием.`)
};

const es_replace_ellipses_desc = /** @type {(inputs: Replace_Ellipses_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazar varios puntos con elipses`)
};

const zh_cn2_replace_ellipses_desc = /** @type {(inputs: Replace_Ellipses_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将多个点替换为省略号`)
};

const ja_replace_ellipses_desc = /** @type {(inputs: Replace_Ellipses_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数のドットを省略記号に置き換える`)
};

const hi_replace_ellipses_desc = /** @type {(inputs: Replace_Ellipses_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एकाधिक बिंदुओं को दीर्घवृत्तों से बदलें`)
};

const pt_pt2_replace_ellipses_desc = /** @type {(inputs: Replace_Ellipses_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitua vários pontos por reticências`)
};

/**
* | output |
* | --- |
* | "Replace multiple dots with ellipses" |
*
* @param {Replace_Ellipses_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const replace_ellipses_desc = /** @type {((inputs?: Replace_Ellipses_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Replace_Ellipses_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_replace_ellipses_desc(inputs)
	if (locale === "de") return de_replace_ellipses_desc(inputs)
	if (locale === "it") return it_replace_ellipses_desc(inputs)
	if (locale === "ru") return ru_replace_ellipses_desc(inputs)
	if (locale === "es") return es_replace_ellipses_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_replace_ellipses_desc(inputs)
	if (locale === "ja") return ja_replace_ellipses_desc(inputs)
	if (locale === "hi") return hi_replace_ellipses_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_replace_ellipses_desc(inputs)
	return en_replace_ellipses_desc(inputs)
});